module.exports = __webpack_public_path__ + "img/GH-kyujin-marketing001.b6bdc930.webp";